import { Language } from '../../components/constants';
const defaultLanguage = Language.PL;
export { defaultLanguage };